import { legacyPlugins } from "/src/node_modules/nuxt/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}